import { setCookie, getCookie, deleteCookie } from '../../../utils/cookieManager';

const CONSENT_COOKIE_NAME = 'clarity_consent';
const CONSENT_EXPIRY_DAYS = 365;

export function saveConsentToCookie(consent) {
  try {
    const consentData = {
      ...consent,
      timestamp: Date.now(),
      expiresAt: Date.now() + (CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    };
    
    const cookieValue = encodeURIComponent(JSON.stringify(consentData));
    setCookie(CONSENT_COOKIE_NAME, cookieValue, CONSENT_EXPIRY_DAYS);
  } catch (error) {
    console.error('Failed to save consent to cookie:', error);
  }
}

export function getConsentFromCookie() {
  try {
    const cookieValue = getCookie(CONSENT_COOKIE_NAME);
    if (!cookieValue) return null;
    
    const consentData = JSON.parse(decodeURIComponent(cookieValue));
    
    // Check if consent has expired
    if (Date.now() > consentData.expiresAt) {
      deleteCookie(CONSENT_COOKIE_NAME);
      return null;
    }
    
    return {
      analytics_Storage: consentData.analytics_Storage,
      ad_Storage: consentData.ad_Storage
    };
  } catch (error) {
    console.error('Failed to get consent from cookie:', error);
    return null;
  }
}


